import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';

// plugin
import * as AOS from 'aos';  

// Service
import { GlobalService } from './shared/service/global.service';
import { ApiService } from './shared/service/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  
})
export class AppComponent implements OnInit, AfterViewInit{

    loading;
    currentRouting = [];
    footer;
    subHeader;

    constructor( private globalService : GlobalService,
                  private router: Router,
                  private apiService: ApiService,
                  private renderer: Renderer2) {}
    
    ngOnInit() {
       // Check browser support Local Storage for language
       let storageUrl = window.localStorage.getItem("language");
       if(storageUrl != null){
           // Check browser support Local Storage
         if (typeof(Storage) !== "undefined") {
           // Store
           window.localStorage.setItem("language", storageUrl);
         } else {
           window.localStorage.setItem("language", "en");
         }
         this.apiService.giveLang(storageUrl);
       }else{
         this.apiService.giveLang('en');
         window.localStorage.setItem("language", "en");
       }
       
      // animation
      setTimeout(()=>{ 
        AOS.init({
          // disable: 'mobile',
          // offset: 200,
          once: true
        });
      }, 1000);

      // API FOOTER AND SUB HEADER + google analytics
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentRouting = this.router.url.split("/", 4);
          if(this.currentRouting[1] != 'not-found' && this.currentRouting[1] != 'server-error'){
            if(this.currentRouting[3]){
              this.apiService.getDataApi('getNextMenuByLink?slug=other/'+this.currentRouting[3]).subscribe(response => {
                this.footer = response.data;
              });
            }else if(this.currentRouting[2]){
              this.apiService.getDataApi('getNextMenuByLink?slug='+this.currentRouting[2]).subscribe(response => {
                this.footer = response.data;
              });
            }else {
              this.apiService.getDataApi('getNextMenuByLink?slug='+this.currentRouting[1]).subscribe(response => {
                this.footer = response.data;
              });
            }
            this.apiService.getDataApi('getSubHeaderByLink/'+this.currentRouting[1]).subscribe(response => {
              this.subHeader = response.data;
            });
          }else{
            this.footer = null;
            this.subHeader = null;
          }
        }
      });

      // Loading Page
      this.globalService.isLoading.subscribe(data => {
        this.loading = data;
        if(this.loading == true){
          this.renderer.addClass(document.body, 'overflow-hidden');
        }else{
          this.renderer.removeClass(document.body, 'overflow-hidden');
        }
      });
    }

    ngAfterViewInit(){
      /* Create an alert to show if the browser is IE or not */
      if(this.isIE()){
        alert('Opss Internet Explorer already outdated, please use another browser such Google, Mozilla, Safari or other updated browser to get better experience while accessing this website!');
      };
    }

    // is IE 
    isIE() {
      var ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones */
      var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
      
      return is_ie; 
    }

}
